import React from "react";

export default function ContactSupport({ onClose }) {
  return (
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title brand-purple">Contact support</h5>
        <button type="button" className="btn-close" onClick={onClose}></button>
      </div>

      <div className="modal-body">
        <p className="mb-3">
          If you need help with your website or subscription, you can contact our support team.
        </p>

        <p className="fw-bold mb-1 brand-purple">Support email</p>
        <p className="mb-3 brand-dark-purple">Info@BorderCitySoftware.com</p>
      </div>

      <div className="modal-footer">
        <button
          type="button"
          className="btn brand-purple-inline"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
}
